import React from 'react'

const PurchaseOrder2 = () => {
  return (
    <div>PurchaseOrder2</div>
  )
}

export default PurchaseOrder2